import { render, staticRenderFns } from "./PhoneOnly.vue?vue&type=template&id=915d7496&"
import script from "./PhoneOnly.vue?vue&type=script&lang=js&"
export * from "./PhoneOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports